import { constants } from './constants';

export var numbers = {
    roundToDecimal,
    pixelsToUnits,
    unitsToPixels,
}

export function roundToDecimal(number, decimalPlaces = 2) {
    if (typeof number !== 'number') {
        number = parseFloat(number);
    }
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.round((number + Number.EPSILON) * multiplier) / multiplier;
}

export function pixelsToUnits(number, units) {
    const result = number / constants.FORM_PPI;
    if (units === 'cm') {
        return roundToDecimal(result * constants.INCHES_PER_CM, 1);
    }
    return roundToDecimal(result, 2);
}

export function unitsToPixels(number, units) {
    if (units === 'cm') {
        number /= constants.INCHES_PER_CM;
    }
    return Math.round(number * constants.FORM_PPI);
}

export function lenientParseFloat(str) {
    if (typeof str === 'number') return str;
    str = str.replace(/^\D*(\d+(?:\.\d+)?)\D*$/g, '$1');
    return parseFloat(str);
}
